import { render, staticRenderFns } from "./ConsolidarCompraParaUmaFilial.vue?vue&type=template&id=1623c9de&scoped=true"
import script from "./ConsolidarCompraParaUmaFilial.vue?vue&type=script&setup=true&lang=js"
export * from "./ConsolidarCompraParaUmaFilial.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1623c9de",
  null
  
)

export default component.exports